export const calculateLabelInterval = (length: number) => {
  return length >= 12 ? Math.floor(length / 7) : 0;
};
